module.exports = __webpack_public_path__ + "static/opportunity-mobile-c84850b93006143189cdccb47283591b.svg";